// extracted by mini-css-extract-plugin
module.exports = {"formStatusWrapper":"src-components-FormResponse-FormStatus-styles___formStatusWrapper"};